import { dew as _encodeFunctionDataDew } from "../../utils/abi/encodeFunctionData.js";
import { dew as _getActionDew } from "../../utils/getAction.js";
import { dew as _sendTransactionDew } from "./sendTransaction.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.writeContract = void 0;
  const encodeFunctionData_js_1 = _encodeFunctionDataDew();
  const getAction_js_1 = _getActionDew();
  const sendTransaction_js_1 = _sendTransactionDew();
  async function writeContract(client, {
    abi,
    address,
    args,
    dataSuffix,
    functionName,
    ...request
  }) {
    const data = (0, encodeFunctionData_js_1.encodeFunctionData)({
      abi,
      args,
      functionName
    });
    const hash = await (0, getAction_js_1.getAction)(client, sendTransaction_js_1.sendTransaction, "sendTransaction")({
      data: `${data}${dataSuffix ? dataSuffix.replace("0x", "") : ""}`,
      to: address,
      ...request
    });
    return hash;
  }
  exports.writeContract = writeContract;
  //# sourceMappingURL=writeContract.js.map
  return exports;
}